export default __webpack_public_path__ + "static/media/60t.f016c1ab.jpg";